
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transform-data/macro",
      function () {
        return require("private-next-pages/transform-data/macro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transform-data/macro"])
      });
    }
  